export const togetheraiModels = {
    id: "togetherai",
    name: "Together AI",
    npm: "@ai-sdk/togetherai",
    doc: "https://docs.together.ai/docs/serverless-models",
    env: ["TOGETHER_API_KEY"],
    models: {
        "deepseek-ai/DeepSeek-V3": {
            id: "deepseek-ai/DeepSeek-V3",
            name: "DeepSeek V3",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-07",
            release_date: "2025-01-20",
            last_updated: "2025-05-29",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 1.25,
                output: 1.25,
            },
            limit: {
                context: 131072,
                output: 12288,
            },
        },
        "deepseek-ai/DeepSeek-R1": {
            id: "deepseek-ai/DeepSeek-R1",
            name: "DeepSeek R1",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: false,
            knowledge: "2024-07",
            release_date: "2024-12-26",
            last_updated: "2025-03-24",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 3,
                output: 7,
            },
            limit: {
                context: 163839,
                output: 12288,
            },
        },
        "openai/gpt-oss-120b": {
            id: "openai/gpt-oss-120b",
            name: "GPT OSS 120B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-05",
            last_updated: "2025-08-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.15,
                output: 0.6,
            },
            limit: {
                context: 131072,
                output: 131072,
            },
        },
        "Qwen/Qwen3-Coder-480B-A35B-Instruct-FP8": {
            id: "Qwen/Qwen3-Coder-480B-A35B-Instruct-FP8",
            name: "Qwen3 Coder 480B A35B Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-23",
            last_updated: "2025-07-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 2,
                output: 2,
            },
            limit: {
                context: 262144,
                output: 66536,
            },
        },
        "meta-llama/Llama-3.3-70B-Instruct-Turbo": {
            id: "meta-llama/Llama-3.3-70B-Instruct-Turbo",
            name: "Llama 3.3 70B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2024-12-06",
            last_updated: "2024-12-06",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.88,
                output: 0.88,
            },
            limit: {
                context: 131072,
                output: 66536,
            },
        },
        "moonshotai/Kimi-K2-Instruct": {
            id: "moonshotai/Kimi-K2-Instruct",
            name: "Kimi K2 Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-07-14",
            last_updated: "2025-07-14",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 1,
                output: 3,
            },
            limit: {
                context: 131072,
                output: 32768,
            },
        },
    },
};
export default togetheraiModels;
//# sourceMappingURL=togetherai.js.map